const REFERRAL_CODE_KEY = 'referral_code';
const COOKIE_NAME = 'ggdriive_referral';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 30; // 30 days

export function saveReferralCode(code: string): void {
  const normalized = code.trim().toUpperCase();
  if (!normalized) return;

  // Preserve the first valid referral attribution. Never overwrite an
  // existing referral with a later code.
  const existing = getReferralCode();
  if (existing) return;

  try {
    localStorage.setItem(REFERRAL_CODE_KEY, normalized);
  } catch {
    // Ignore storage failures; the cookie is the fallback.
  }

  // Keep the cookie available across the whole application, including
  // /bedrive and production deployments at the domain root.
  document.cookie = [
    `${COOKIE_NAME}=${encodeURIComponent(normalized)}`,
    `Max-Age=${COOKIE_MAX_AGE}`,
    'Path=/',
    'SameSite=Lax',
  ].join('; ');
}

export function getReferralCode(): string | null {
  try {
    const localStorageCode = localStorage.getItem(REFERRAL_CODE_KEY);
    if (localStorageCode) return localStorageCode;
  } catch {
    // Fall through to cookie.
  }

  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`),
  );
  return match ? decodeURIComponent(match[1]) : null;
}

export function clearReferralCode(): void {
  try {
    localStorage.removeItem(REFERRAL_CODE_KEY);
  } catch {
    // Ignore storage failures.
  }

  document.cookie = `${COOKIE_NAME}=; Max-Age=0; Path=/; SameSite=Lax`;
}

export function hasReferralCode(): boolean {
  return getReferralCode() !== null;
}
